/**
 * This file is auto-generated from error.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const backToHome: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Back to Home';
        case 'pl':
            return 'Powrót do strony głównej';
    }
};
